import { $can } from '@pendo/permissions';

function checkPermission (appId, action, entity, source = 'ANY', target = 'ANY') {
    if (!appId || !action) {
        return false;
    }

    return $can(appId)
        .entity(entity)
        .action(action)
        .source(source)
        .target(target);
}

export function canCreateEmail ({ appId, source, target }) {
    return checkPermission(appId, 'create', 'email', source, target);
}

export function canUpdateEmail ({ appId, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'edit', 'email', source, target);
}

export function canDeleteEmail ({ appId, source, target, email }) {
    if (!source && email?.status === 'public') {
        source = 'public';
    }

    return checkPermission(appId, 'remove', 'email', source, target);
}

export function canPublishEmail ({ appId, source, target }) {
    return checkPermission(appId, 'publish', 'email', source, target);
}
